import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QuizState } from '../reducers/quiz.reducer';
import { QUIZ_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<QuizState>(QUIZ_FEATURE_KEY);

export const selectLoaded = (id: string) => createSelector(selectState, (state: QuizState) => state.entries[id]?.loaded ?? null);
export const selectLoading = (id: string) => createSelector(selectState, (state: QuizState) => state.entries[id]?.loading ?? false);
export const selectQuiz = (id: string) => createSelector(selectState, (state: QuizState) => state.entries[id]?.quiz ?? null);
export const selectSaving = createSelector(selectState, (state: QuizState) => state.saving);
export const selectSaved = createSelector(selectState, (state: QuizState) => state.saved);
export const selectError = (id: string) => createSelector(selectState, (state: QuizState) => state.entries[id]?.error ?? null);
export const selectCreatedId = createSelector(selectState, (state: QuizState) => state.createdId);
